module.exports = __webpack_public_path__ + "media/images/city/002-alcala-gate-6198ec311d25277f07e9933a9b290f8c.svg";